<template>
  <SogPage
    title="Verbraucherinformationen"
    flex-direction="flex-column"
  >
    <div>
      <p>
        <a
          href="pdf\WAKAM_IPID.pdf"
          class="link"
          target="_blank"
        >
          Informationsblatt
        </a>
      </p>
      <p>
        <a
          href="pdf\WAKAM_Insurance_information.pdf"
          class="link"
          target="_blank"
        >
          Versicherungsinformationen
        </a>
      </p>
      <p>
        <a
          href="pdf\WAKAM_AKB.pdf"
          class="link"
          target="_blank"
        >
          Allgemeine Bedingungen für die Kfz-Haftpflichtversicherung (AKB)
        </a>
      </p>
      <p>
        <a
          href="pdf\WAKAM_GDPR.pdf"
          class="link"
          target="_blank"
        >
          Merkblatt zur Datenverarbeitung
        </a>
      </p>
      <p>
        <a
          href="schaden"
          class="link"
        >
          Schaden melden
        </a>
      </p>
    </div>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
</script>
<style scoped>
.link,
.link:hover {
  color: #fff;
}
</style>
